export const COPIED_FEEDBACK_DURATION: number = 2000;

interface CopyToClipboardParams {
  value: string;
  clipboard: Pick<Clipboard, 'writeText'>;
  feedbackTimeoutRef: { current: ReturnType<typeof setTimeout> | null };
  setIsCopied: (isCopied: boolean) => void;
}

export async function copyToClipboard({
  value,
  clipboard,
  feedbackTimeoutRef,
  setIsCopied,
}: CopyToClipboardParams): Promise<void> {
  try {
    await clipboard.writeText(value);
    setIsCopied(true);
    if (feedbackTimeoutRef.current) clearTimeout(feedbackTimeoutRef.current);
    feedbackTimeoutRef.current = setTimeout((): void => {
      setIsCopied(false);
      feedbackTimeoutRef.current = null;
    }, COPIED_FEEDBACK_DURATION);
  } catch (error: unknown) {
    console.warn('[copyToClipboard] Failed to copy to clipboard:', error);
  }
}
